<template>
  <main :aria-label="$t('general.inactive_users')" class="user-passive-page">
    <CompanyBreadcrumb :aria-label="$t('general.inactive_users')"
                       :home-aria-label="$t('general.home')"
                       :items="breadcrumbItems"
    />

    <div v-if="successMessage" class="card user-passive-alert-card">
      <div class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p>
          <i class="uil-check"></i> {{ successMessage }}
        </p>
      </div>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle user-passive-page-header">
      <div class="section-header-left">
        <h2 class="user-passive-page-title">
          <span>{{ $t('general.inactive_groups') }}</span>
        </h2>
      </div>
      <div class="section-header-right"></div>
    </div>

    <div class="card user-passive-list-card">
      <CompanyTabs :tabs="passiveTabs"
                   animation="uk-animation-fade"
                   class="user-passive-tabs-shell"
                   content-id="user-passive-switcher"
                   nav-id="user-passive-tabs"
      >
            <li>
              <div class="card-header actions-toolbar border-0 user-passive-toolbar">
                <div class="d-flex justify-content-between user-passive-toolbar-inner">
                  <div class="user-passive-toolbar-search">
                    <search-input v-model="user_data.filter.search"
                                  :aria-label="$t('general.first_name_and_last_name_or_id_no')"
                                  :control-height="48"
                                  :debounce="0"
                                  :placeholder="$t('general.first_name_and_last_name_or_id_no')"
                    />
                  </div>
                  <div class="d-flex user-passive-toolbar-actions">
                    <sort-dropdown :sort-options="sortOptions" @sort-selected="sortUsers"/>

                    <a :aria-label="$t('general.filter_list')"
                       :uk-tooltip="$t('general.filter_list')"
                       class="btn btn-icon btn-hover btn-circle"
                       href="javascript:void(0)">
                      <i class="uil-filter"></i>
                    </a>
                    <UserFilter @getFilter="getFilter($event)"></UserFilter>

                    <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
                                           @download="exportList(0)"/>
                  </div>
                </div>
              </div>

              <default-loading v-if="user_loading"></default-loading>
              <template v-else>
                <div class="sf-table sf-table--zebra sf-table--hover user-passive-table-wrap">
                  <table>
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('general.first_name_and_last_name') }}</th>
                      <th scope="col">{{ $t('users.title') }}</th>
                      <th scope="col">{{ $t('users.mission') }}</th>
                      <th scope="col">{{ $t("general.corporation") }}</th>
                      <th scope="col">{{ $t('general.user_status') }}</th>
                      <th scope="col">{{ $t('users.last_login_date') }}</th>
                      <th class="sf-table__col-actions" scope="col"></th>
                    </tr>
                    </thead>
                    <tbody class="list">
                    <tr v-for="(item, index) in formattedItem" :key="index">
                      <th scope="row">
                        <div class="sf-table__media">
                          <div>
                            <div class="avatar-parent-child user-passive-avatar">
                              <AvatarOrIcon :size-px="32" :src="item.photo_link"/>
                              <span :class="item.status_id === 1 ? 'bg-success' : 'bg-offline'"
                                    class="avatar-child avatar-badge"></span>
                            </div>
                          </div>
                          <div class="sf-table__media-body">
                            <a class="sf-table__name" @click="profileItem = item">{{ item.fullname }}</a>
                            <small class="sf-table__meta">#{{ item.id }}</small>
                          </div>
                        </div>
                      </th>
                      <td>{{ item.title }}</td>
                      <td>{{ item.position }}</td>
                      <td>{{ item.corporateName }}</td>
                      <!-- Durum kolonu kurali uygulama genelinde ayni:
                           aktif yesil, pasif kirmizi (bkz. Users/index.vue getUserStatus). -->
                      <td :class="item.status_id === 1 ? 'sf-table__status--success' : 'sf-table__status--danger'"
                          class="sf-table__status">
                        {{ item.status_id === 1 ? $t('general.active') : $t('general.passive') }}
                      </td>
                      <td>{{ item.last_login_at }}</td>
                      <td class="sf-table__col-actions">
                        <div class="sf-table__actions">
                          <a :uk-tooltip="$t('general.set_active')" aria-expanded="false"
                             class="btn btn-icon btn-hover btn-sm btn-circle"
                             href="#" title="" @click="userUpdateStatus(item.id)">
                            <i class="uil-check-circle text-success"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination v-if="user_data.pagination && user_data.pagination.hasOwnProperty('links')"
                            :pagination="user_data.pagination"
                            class="mb-3 mt-2 user-passive-pagination" @changePage="setPage($event)"></pagination>
              </template>
            </li>
            <li>
              <div class="card-header actions-toolbar border-0 user-passive-toolbar">
                <div class="d-flex justify-content-between user-passive-toolbar-inner">
                  <div class="user-passive-toolbar-search">
                    <search-input v-model="group.filter.search"
                                  :aria-label="$t('user_group.list.search')"
                                  :control-height="48"
                                  :debounce="0"
                                  :placeholder="$t('user_group.list.search')"
                    />
                  </div>

                  <div class="d-flex user-passive-toolbar-actions">
                    <sort-dropdown :sort-options="sortOptions" @sort-selected="sortGroups"/>

                    <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
                                           @download="exportList(0, groupExportURL, 'Gruplar')"/>
                  </div>
                </div>
              </div>
              <default-loading v-if="group_loading"></default-loading>
              <template v-else>
                <div class="sf-table sf-table--zebra sf-table--hover user-passive-table-wrap">
                  <table>
                    <thead>
                    <tr>
                      <th scope="col">{{ $t("user_group.list.name") }}</th>
                      <th scope="col">{{ $t("user_group.list.user_count") }}</th>
                      <th scope="col">{{ $t("general.created_at") }}</th>
                      <th scope="col">{{ $t("general.status") }}</th>
                      <th class="sf-table__col-actions" scope="col"></th>
                    </tr>
                    </thead>
                    <tbody class="list">
                    <tr v-for="item in formattedGroupItem" :key="item.id">
                      <th scope="row">
                        <div class="sf-table__media">
                          <div>
                            <div class="avatar-parent-child user-passive-avatar">
                              <!-- rounded-circle YOK: gruplar kare, kullanicilar yuvarlak.
                                   `.avatar` sarmalayicisi sart, yoksa bootstrap'in
                                   `.avatar + .avatar-badge` kurali eslesmez ve rozet boyutsuz kalir. -->
                              <div class="avatar user-passive-avatar-inner">
                                <i class="icon-feather-users"></i>
                              </div>
                              <span :class="item.status_id ? 'bg-success' : 'bg-offline'"
                                    class="avatar-child avatar-badge"></span>
                            </div>
                          </div>
                          <div class="sf-table__media-body">
                            <a class="sf-table__name" href="javascript:void(0)">{{ item.name }}</a>
                          </div>
                        </div>
                      </th>
                      <td><i class="uil-user"></i> {{ item.count }}</td>
                      <td><i class="uil-calendar-alt"></i> {{ item.created_at }}</td>
                      <td :class="item.status_id ? 'sf-table__status--success' : 'sf-table__status--danger'"
                          class="sf-table__status">
                        {{ item.status }}
                      </td>
                      <td class="sf-table__col-actions">
                        <div class="sf-table__actions">
                          <a :uk-tooltip="$t('general.set_active')" aria-expanded="false"
                             class="btn btn-icon btn-hover btn-sm btn-circle"
                             href="#" title="" @click="groupUpdateStatus(item.id)">
                            <i class="uil-check-circle text-success"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination v-if="group.pagination && group.pagination.hasOwnProperty('links')"
                            :pagination="group.pagination"
                            class="user-passive-pagination"
                            @changePage="setPage($event, false)"></pagination>
              </template>
            </li>
      </CompanyTabs>
    </div>

    <!-- modalClosed sart: activeItem sifirlanmazsa modal bir daha acilmaz -->
    <UserProfile v-if="profileItem && formattedUserDetail"
                 :item="profileItem"
                 :user_detail="formattedUserDetail"
                 @modalClosed="profileItem = null"/>
  </main>
</template>

<script>
import UserFilter from "@/view/company/User/Filter";
import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import SearchInput from "@/view/components/inputs/SearchInput.vue";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import CompanyTabs from "@/view/company/components/tabs/CompanyTabs.vue";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
  ERROR,
  ITEMS,
  UPDATE_USER,
  LOADING,
  SUCCESS as USER_SUCCES
} from "@/core/services/store/user.module";

import group_module, {
  BASE_URL as GROUP_BASE_URL,
  MODULE_NAME as GROUP_MODULE_NAME,
  ERROR as GROUP_ERROR,
  ITEMS as GROUP_ITEMS,
  CREATE_ITEM as GROUP_UPDATE_ITEM,
  LOADING as GROUP_LOADING,
  SUCCESS as GROUP_SUCCESS
} from "@/core/services/store/user_group.module";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";
import { showError } from "@/utils/alertUtils";
import { downloadFromUrl, exportFileName, readBlobError } from "@/utils/fileDownload";

export default {
  name: "Users",
  components: {
    ExcelDownloadButton,
    UserFilter,
    Pagination,
    DefaultLoading,
    AvatarOrIcon,
    CompanyBreadcrumb,
    SearchInput,
    SortDropdown,
    CompanyTabs,
    UserProfile,
  },
  data() {
    return {
      successMessage: null,
      // Profili acilan kullanici (isim hucresine tiklanınca set edilir)
      profileItem: null,
      groupExportURL: '/api/group/export',
      keepFilter: null,
      user_data: {
        pagination: null,
        activeItem: null,
        page: 1,
        per_page: 10,
        filter: {
          search: null,
          order: "desc",
          sort: "id",
          order_by: "id",
        },
      },
      group: {
        pagination: null,
        activeItem: null,
        page: 1,
        per_page: 10,
        filter: {
          search: null,
          order_by: "id",
          order: "desc",
          sort: "desc",
        },
      },
      isReportDownloading: false
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(GROUP_MODULE_NAME, group_module);
    registerStoreModule(USER_DETAIL_MODULE, user_detail_module);
  },
  computed: {
    passiveTabs() {
      return [
        { key: "users", icon: "uil-user", label: this.$t("general.inactive_users") },
        { key: "groups", icon: "uil-users-alt", label: this.$t("general.inactive_groups") },
      ];
    },
    user_detail: {
      get() {
        return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
      },
      set(value) {
      },
    },
    formattedUserDetail() {
      return this.user_detail === null ? null : this.user_detail;
    },
    breadcrumbItems() {
      return [
        { name: this.$t("user_group.users") },
        { name: this.$t("general.inactive_groups") },
      ];
    },
    // Her iki sekme de aynı seçenekleri kullanıyor; ayıran şey
    // sort-selected'ın hangi adaptöre bağlandığı (sortUsers / sortGroups).
    sortOptions() {
      return [
        { key: "text-asc", sort: "name", order: "asc", label: this.$t("sorting.a_z") },
        { key: "text-desc", sort: "name", order: "desc", label: this.$t("sorting.z_a") },
        { key: "created_at-asc", sort: "id", order: "asc", label: this.$t("sorting.created_at_old") },
        { key: "created_at-desc", sort: "id", order: "desc", label: this.$t("sorting.created_at_new") },
      ];
    },
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    user_loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    group_loading: {
      get() {
        return store.getters[GROUP_MODULE_NAME + "/" + GROUP_LOADING];
      },
      set(value) {
      },
    },
    group_success() {
      return store.getters[GROUP_MODULE_NAME + "/" + GROUP_SUCCESS];
    },
    user_success() {
      return store.getters[MODULE_NAME + "/" + USER_SUCCES];
    },
    groups: {
      get() {
        return store.getters[GROUP_MODULE_NAME + "/" + GROUP_ITEMS];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedItem() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.user_data.pagination = this.items;

      this.items.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          status_id: currentItem.status_id,
          photo_link: currentItem.photo_link,
          fullname: [currentItem.name, currentItem.surname].join(" "),
          title: currentItem.title ? currentItem.title.name : "-",
          position: currentItem.position ? currentItem.position.name : "-",
          corporateName: currentItem.corporate?.name || "-",
          created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: currentItem.last_login_at
              ? moment(currentItem.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });

      return results;
    },
    formattedGroupItem() {
      let results = [];
      if (this.groups === null || !("data" in this.groups)) return [];

      for (let i = 0; i < this.groups.data.length; i++) {
        let currentItem = this.groups.data[i];
        this.group.pagination = this.groups;
        if (currentItem) {
          results.push({
            id: currentItem.id,
            name: currentItem.name,
            // ham deger renklendirme icin, ceviri metin icin
            status_id: currentItem.status,
            status: currentItem.status
                ? this.$t("general.active")
                : this.$t("general.passive"),
            count: currentItem.count,
            created_at: currentItem.created_at
                ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
                : "-",
          });
        }
      }
      return results;
    },
  },
  methods: {
    getUserDetail(id) {
      store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail-admin" + "/" + id,
      });
    },
    // aktif kullanıcı filtresinden (keepFilter) tek noktada istek parametreleri üretilir
    buildUserRequestFilters() {
      const activeFilter = this.keepFilter || {};

      let filters = {
        like: this.user_data.filter.search,
        sort: this.user_data.filter.sort,
        order: this.user_data.filter.order,
        order_by: this.user_data.filter.order_by,
        status_id: 0,
        from_date: activeFilter.from_date ?? null,
        to_date: activeFilter.to_date ?? null,
        position_id: activeFilter.position_id ?? null,
        title_id: activeFilter.title_id ?? null,
        region_id: activeFilter.region_id ?? null,
        department_id: activeFilter.department_id ?? null,
        branch_id: activeFilter.branch_id ?? null,
      };

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (value && Array.isArray(value) && key !== 'company_id') {
          filters[key] = JSON.stringify(value.map((item) => item.id));
        }
      });

      return filters;
    },
    filterResult(is_user = true, filter = null, page = 1) {
      let self = is_user ? this.user_data : this.group;
      let M_NAME = is_user ? MODULE_NAME : GROUP_MODULE_NAME;
      let B_URL = is_user ? BASE_URL : GROUP_BASE_URL;

      // Kullanıcı sekmesi: keepFilter üzerinden tutarlı filtreleme
      if (is_user) {
        if (filter) {
          this.keepFilter = filter;
        }

        this.$store.dispatch(M_NAME + "/" + GET_ITEMS, {
          url: B_URL,
          filters: {
            ...this.buildUserRequestFilters(),
            page: page,
            per_page: self.per_page,
          },
        });
        return;
      }

      // Grup sekmesi: şirket filtresi yok, sadece arama/sıralama
      let filters = {
        like: self.filter.search,
        page: page,
        per_page: self.per_page,
        sort: self.filter.order,
        order: self.filter.order,
        order_by: self.filter.order_by,
        status_id: 0,
      };

      this.$store.dispatch(M_NAME + "/" + GET_ITEMS, {
        url: B_URL,
        filters: filters,
      });
    },
    userUpdateStatus(id) {
      store.dispatch(MODULE_NAME + '/' + UPDATE_USER, {
        url: BASE_URL + '/status/' + id,
        contents: {
          user: id,
          status_id: 0
        },
        returnType: "stateless",
        acceptPromise: true,
        _method: "put"
      })
    },
    groupUpdateStatus(id) {
      this.$store.dispatch(GROUP_MODULE_NAME + "/" + GROUP_UPDATE_ITEM, {
        url: GROUP_BASE_URL + "/" + id + "/status",
        contents: {
          id: id,
          status_id: 1,
        },
        returnType: "stateless",
        acceptPromise: true,
      })

    },
    getFilter(value) {
      // Yeni filtre geldiyse keepFilter'a yazılır; sayfalama/sıralamada korunur
      this.filterResult(true, value);
    },
    // SortDropdown { sort, order } yayıyor; sortOrder ise (order, sort, is_user)
    // bekliyor. Bu iki adaptör sırayı çevirip doğru sekmeyi hedefliyor.
    sortUsers({ sort, order }) {
      this.sortOrder(order, sort, true);
    },
    sortGroups({ sort, order }) {
      this.sortOrder(order, sort, false);
    },
    sortOrder(order, sort, is_user = true) {
      let self = is_user ? this.user_data : this.group;
      self.page = 1;
      self.filter.order = order;
      self.filter.order_by = sort;
      self.filter.sort = sort;

      this.filterResult(is_user);
    },
    setPage(page, is_user = true) {
      let self = is_user ? this.user_data : this.group;
      self.page = page;
      // Yeni filtre gönderme; keepFilter'daki son filtreyle sadece sayfa değişsin
      this.filterResult(is_user, null, page);
    },
    resetMessages() {
      this.successMessage = null
    },
    // İndirme web/native ayrımı utils/fileDownload.js içinde yapılır;
    // burada sadece "ne indirilecek" tarif edilir.
    buildExportParams(url, status_id) {
      if (status_id == null) {
        return null;
      }
      return url === this.groupExportURL
          ? { status_id }
          : { ...this.buildUserRequestFilters(), status_id };
    },
    async exportList(status_id = null, url = '/api/user/export', file_name = 'passive_users_list') {
      if (this.isReportDownloading) {
        return;
      }
      this.isReportDownloading = true;

      try {
        await downloadFromUrl({
          url: process.env.VUE_APP_BACKEND_APP_URL + url,
          // Kullanıcı export'u listede görünen filtrelerle aynı payload'ı kullanır.
          // Grup export'una kullanıcı filtreleri (position_id, title_id, like,
          // order_by ...) GÖNDERİLMEZ; o listeyle ilgisi yok. Group/List.vue
          // de aynı uca yalnızca status_id gönderiyor.
          params: this.buildExportParams(url, status_id),
          headers: this.apiHeaders,
          fileName: exportFileName(file_name),
        });
      } catch (error) {
        // Eskiden hata sessizce yutuluyordu. responseType 'blob' olduğu için
        // hata gövdesi de Blob gelir; readBlobError gerçek mesajı çıkarır.
        showError(await readBlobError(error));
      } finally {
        this.isReportDownloading = false;
      }
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin pasif kullanıcıları gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
    this.filterResult(false);
  },
  watch: {
    profileItem(value) {
      if (value) {
        this.getUserDetail(value.id);
      }
    },
    user_success: function (val) {
      if (val) {
        this.successMessage = this.$t('general.successfully_updated')
        this.filterResult();
      }
    },
    group_success: function (val) {
      if (val) {
        this.successMessage = this.$t('general.successfully_updated')
        this.filterResult(false)
      }
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    'user_data.filter.search'() {
      this.debouncedFilterResult(true);
    },
    'group.filter.search'() {
      this.debouncedFilterResult(false);
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 1500);
    this.debouncedFilterResult = _.debounce(this.filterResult, 500);
  },
};
</script>
<style scoped>
.user-passive-page {
  --user-passive-primary: var(--primaryColor, #3e416d);
  --user-passive-text: #1e293b;
  --user-passive-muted: #64748b;
  --user-passive-border: #e2e8f0;
  --user-passive-soft: #f6f7fb;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.user-passive-alert-card {
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid var(--user-passive-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.user-passive-page .uk-alert {
  margin: 0;
}

.user-passive-page .uk-alert p {
  margin: 0;
  color: #28a745;
  font-size: 0.875rem;
  line-height: 1.5;
}

.user-passive-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.user-passive-page-header .section-header-right > * {
  margin-left: 0;
}

.user-passive-page-title {
  margin: 0;
  color: var(--user-passive-text);
  font-size: 19px;
  font-weight: 600;
  line-height: 1.3;
}

.user-passive-list-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  margin-top: 0;
  border: 1px solid var(--user-passive-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* CompanyTabs kendi kart cercevesini cizmiyor; nav'in yatay bosluğu
   kart ici hizayi korumak icin burada veriliyor. */
.user-passive-tabs-shell ::v-deep .company-tabs__nav {
  padding: 0 16px;
}

.user-passive-toolbar {
  padding: 16px;
}

.user-passive-toolbar-inner {
  align-items: center;
  gap: 16px;
}

.user-passive-toolbar-search {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 480px;
}

.user-passive-toolbar-search ::v-deep .search-input-component {
  width: 100%;
}

.user-passive-toolbar-actions {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.user-passive-toolbar-actions ::v-deep .btn-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.user-passive-toolbar-actions ::v-deep .btn-circle:active {
  transform: scale(0.98);
  opacity: 0.85;
}

/* Tablo tasarimi .sf-table'dan gelir (assets/scss/_data-table.scss).
   Burada yalnizca sayfaya ozgu degerler ayarlanir. */

.user-passive-avatar {
  width: max-content;
}

/* Grup ikonu: global `.avatar-parent-child i { padding: 13px }` kutuyu
   sisirip rozeti ikondan uzaklastiriyor; sifirlanip sabit olcuye alindi. */
.user-passive-avatar-inner {
  width: 32px;
  height: 32px;
}

.user-passive-avatar-inner i {
  padding: 0;
  font-size: 24px;
  line-height: 1;
}

.user-passive-pagination {
  padding: 0 8px 8px;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

@media (max-width: 959px) {
  .user-passive-page {
    padding: 0 0 24px;
  }

  .user-passive-page-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.3;
  }

  .user-passive-page .uk-alert p {
    font-size: 16px;
  }

  .user-passive-page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .user-passive-page-header .section-header-left,
  .user-passive-page-header .section-header-right {
    width: 100%;
  }

  .user-passive-toolbar-inner {
    flex-direction: column;
    align-items: stretch;
  }

  .user-passive-toolbar-search {
    width: 100%;
    max-width: none;
  }

  .user-passive-toolbar-actions {
    flex-wrap: wrap;
    align-self: flex-end;
    width: auto;
    max-width: 100%;
    margin-left: auto;
    justify-content: flex-end;
  }

  .user-passive-toolbar-actions ::v-deep .btn-circle {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .user-passive-page ::v-deep .uk-dropdown-nav > li > a {
    display: flex;
    align-items: center;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  /* 7 kolonlu tablo mobilde sikistirilmaz, yatay kaydirilir */
  .user-passive-table-wrap {
    --sf-table-min-width: 880px;
  }
}

@media (max-width: 767px) {
  .user-passive-page {
    padding: 0;
  }

  .user-passive-page-title {
    font-size: 24px;
  }

  .user-passive-pagination {
    padding: 0 16px 16px;
  }
}

@media (hover: none) {
  .user-passive-page ::v-deep .btn-hover:hover {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .user-passive-toolbar-actions ::v-deep .btn-circle:active {
    transform: none;
  }
}
</style>
